/**Packages */
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

/**Redux */
import { useDispatch, useSelector } from 'react-redux';
import { setAmountSliderThunk, setPaymentSliderThunk, setCurrentSimulationThunk, setInternalThemeThunk } from '../redux/actions/index';

/* Components */
import Recap from './pages/Recap';
import Offline from './pages/Offline';
import OTPForm from './pages/OTPForm';
import DatiForm from './pages/DatiForm';
import Simulatore from './pages/Simulatore';
import SimulatoreUnMinuto from './pages/SimulatoreUnMinuto';
import AirbrakeErrorBoundary from './shared/AirbrakeErrorBoundary';
import { Loader } from './shared/Loader';
import { ProtectedRoute } from './shared/ProtectedRoute';

/**Helpers */
import { INTERNAL_THEME } from "../helpers/constants";
import { simulation, simulationOneMinute } from '../helpers/mocks/simulation';
import { initialSliderNormal, initialSliderOneMinute } from '../helpers/mocks/sliders';

/**CSS */
import './App.css';

const setBaseSimulation = (
  pathname = window.location.pathname,
  initMockSimulation,
  setCurrentSimulation,
  setAmountSlider,
  setPaymentSlider,
  setInternalTheme
) => {
  
  if(!initMockSimulation) {
    const isSimulatoreOneMinute = pathname.includes('simulatore-commerciale-1-minuto'),
        internalThemeToSet = isSimulatoreOneMinute ? INTERNAL_THEME.COMPASS_ONE_MINUTE_SIMULATOR : INTERNAL_THEME.COMPASS_BASE_SIMULATOR,
        simulationToSet = isSimulatoreOneMinute ? simulationOneMinute : simulation,
        amountSliderToSet = isSimulatoreOneMinute ? initialSliderOneMinute.amount : initialSliderNormal.amount,
        paymentSliderToSet = isSimulatoreOneMinute ? initialSliderOneMinute.payment : initialSliderNormal.payment;


    setCurrentSimulation({...simulationToSet});
    setAmountSlider({...amountSliderToSet});
    setPaymentSlider({...paymentSliderToSet});
    setInternalTheme(internalThemeToSet);
  }
}

function App() {
  const history = useHistory();
  const initMockSimulation = history?.location?.state?.returnButtonClicked || false;

  //Loader
  const loaderState = useSelector(state => state.loader);
  const loaderVisible = (loaderState && loaderState.visible) || false;

  const dispatch = useDispatch();
  const setCurrentSimulation = (currentSimulationData) => dispatch(setCurrentSimulationThunk(currentSimulationData));
  const setAmountSlider = (amountOptions) => dispatch(setAmountSliderThunk(amountOptions));
  const setPaymentSlider = (paymentOptions) => dispatch(setPaymentSliderThunk(paymentOptions));
  const setInternalTheme = (internalTheme) => dispatch(setInternalThemeThunk(internalTheme));

  setBaseSimulation(
    window.location.pathname,
    initMockSimulation,
    setCurrentSimulation,
    setAmountSlider,
    setPaymentSlider,
    setInternalTheme
  );

  return (
    <Router basename="/simulatore">
      <Loader
        visible={loaderVisible}
      />
      <Switch>
        <Route exact strict path="/dati-utente.html">
          <AirbrakeErrorBoundary>
            <DatiForm />
          </AirbrakeErrorBoundary>
        </Route>
        <Route exact strict path="/conferma-otp.html">
          <AirbrakeErrorBoundary>
            <OTPForm />
          </AirbrakeErrorBoundary>
        </Route>
        <Route exact strict path="/simulatore-commerciale.html">
          <AirbrakeErrorBoundary>
            <Simulatore />
          </AirbrakeErrorBoundary>
        </Route>
        <Route exact strict path="/simulatore-commerciale-1-minuto.html">
          <AirbrakeErrorBoundary>
            <SimulatoreUnMinuto />
          </AirbrakeErrorBoundary>
        </Route>
        <ProtectedRoute exact strict path="/risultato-profilo-web.html" component={Recap} />
        <Route exact strict path="/offline.html">
          <AirbrakeErrorBoundary>
            <Offline />
          </AirbrakeErrorBoundary>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
